<template>
    <div class="com-codics-hbb-order-admin-body">
        <MySideBar v-model="isShow" :style="{ 'width': isShow ? '256px' : '50px' }" :data="userInfo?.user?.member==0 ? leftBarData : userInfo?.user?.menus"></MySideBar>
        <div class="com-codics-hbb-order-admin-body-contanier" :style="{ 'padding-left': isShow ? '256px' : '50px' }">
            <AdminHeader></AdminHeader>
            <router-view class="com-codics-hbb-order-admin-body-content"></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MySideBar from '@/components/MySideBar';
import AdminHeader from '@/components/AdminHeader';
export default {
    data() {
        return {
            isShow: false,
            leftBarData: [
                {
                    icon: "&#xe88c;",
                    title: "用户管理",
                    state: false,
                    child: [
                        {
                            title: "员工管理",
                            url: "#"
                        },
                        {
                            title: "角色管理",
                            url: "#"
                        },
                        {
                            title: "菜单管理",
                            url: "#"
                        },
                        {
                            title: "客户管理",
                            url: "#"
                        }
                    ]
                },
                {
                    icon: "&#xe6d4;",
                    title: "采购管理",
                    state: false,
                    child: [
                        {
                            title: "商品管理",
                            url: "#"
                        },
                        {
                            title: "分类管理",
                            url: "#"
                        },
                        {
                            title: "品牌管理",
                            url: "#"
                        },
                        {
                            title: "采购管理",
                            url: "#"
                        },
                        {
                            title: "订单管理",
                            url: "#"
                        },
                        {
                            title: "采购中心",
                            url: "#"
                        }
                    ]
                },
                {
                    icon: "&#xe6ed;",
                    title: "系统管理",
                    state: false,
                    child: [
                        {
                            title: "消息管理",
                            url: "#"
                        },
                        {
                            title: "操作日志",
                            url: "#"
                        },
                        {
                            title: "个人信息",
                            url: "#"
                        }
                    ]
                }
            ]
        }
    },
    mounted() {

    },
    methods: {

    },
    computed: {
        ...mapState(['userInfo'])
    },
    components: {
        MySideBar,
        AdminHeader
    }
}
</script>

<style>
.com-codics-hbb-order-admin-body {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    padding: 0;
    margin: 0;
    background: var(--bg-color);
    box-sizing: border-box;
    transition: .3s all ease;
}

.com-codics-hbb-order-admin-body-contanier {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    transition: .3s all ease;
}

.com-codics-hbb-order-admin-body-content {
    height: calc(100% - 50px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    transition: .3s all ease;
}
</style>